// extracted by mini-css-extract-plugin
export var animationContainer = "_m6-0";
export var footer = "_m6-1";
export var gray = "_m6-2";
export var lineItem = "_m6-3";
export var lineItemImage = "_m6-4";
export var lineItemInfo = "_m6-5";
export var lineItemText = "_m6-6";
export var lineItems = "_m6-7";
export var modalContent = "_m6-8";
export var options = "_m6-9";
export var orderName = "_m6-a";
export var refundAmount = "_m6-b";